// removed by extract-text-webpack-plugin
module.exports = {"cardContainer":"src-pageComponents----card-module---cardContainer---UfkDZ","halfCardContainer":"src-pageComponents----card-module---halfCardContainer---uqlkX","card":"src-pageComponents----card-module---card---3RPWu","halfCard":"src-pageComponents----card-module---halfCard---Bpz4V","cardBody":"src-pageComponents----card-module---cardBody---2bRHW","singleCard":"src-pageComponents----card-module---singleCard---8Ws-b"};


//////////////////
// WEBPACK FOOTER
// ./src/pageComponents/card.module.css
// module id = 60
// module chunks = 168707334958949